module.exports = __webpack_public_path__ + "static/media/success_habits.718a1583.jpg";